
/**
 * Api業務エラー
 *
 * @export
 * @class HttpBusinessErrorResponse
 */
export class HttpBusinessErrorResponse extends Error {

  /** エラーメッセージ */
  message: string;
  /** Apiレスポンス */
  error: any;

  /**
   * コンストラクタ.メッセージを設定しない場合は固定のメッセージを設定.
   * @param {*} apiResponse
   * @param {string} message
   * @memberof ApiBusinessError
   */
  constructor(apiResponse: any)
  constructor(apiResponse: any, message: string)

  /**
   * コンストラクタ.
   * @param {*} [apiResponse]
   * @param {string} [message]
   * @memberof ApiBusinessError
   */
  constructor(apiResponse?: any, message?: string,) {
    super(apiResponse);
    Object.setPrototypeOf(this, HttpBusinessErrorResponse.prototype);

    (message)
      ? this.message = "business error!! " + message
      : this.message = "business error!!";

    this.error = apiResponse;
  }
}